import { FC } from 'react';
import { Skeleton, Stack } from '@chakra-ui/react';

export const LoadingState: FC = () => {
  return (
    <Stack flex={1}>
      <Skeleton height="12" />
      <Skeleton height="95%" />
    </Stack>
  );
};
